export default function currencyFormatter(value) {
  return (
    (value || value === 0) && value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  )
}
